import { BrowserRouter, Routes, Route } from "react-router-dom";
import ExpertDetails from "./pages/ExpertDetails";
import "./styles/globals.css";
import { UrlProvider } from "./contexts/UrlContext";
import { ConsultantProvider } from "./contexts/ConsultantContext";
import ReactGA from "react-ga4";
import PageNotFound from "./pages/PageNotFound";
import ErrorPage from "./pages/ErrorPage";
import React, { useEffect } from "react";
import ConsultantLogin from "./pages/ConsultantLogin";
import InvalidConsultant from "./components/InvalidConsultant";
let URI;
if (process.env.REACT_APP_ENVIRONMENT === "development") {
  URI = "https://tool.expertpowerhouse.com.com:3001/";
} else if (process.env.REACT_APP_ENVIRONMENT === "production") {
  URI = "https://tool.expertpowerhouse.com.com/";
} else {
  URI = "http://localhost:3000/";
}

ReactGA.initialize("G-R701RR6DZJ");

export default function App() {
  return (
    <BrowserRouter>
      <UrlProvider>
        <Routes>
          <Route path="/" element={<ConsultantLogin />} />
          <Route path="/login" element={<ConsultantLogin />} />
          <Route path="/invalid-consultant" element={<InvalidConsultant />} />
          <Route
            path="/app/*"
            element={
              <ConsultantProvider>
                <Routes>
                  {/* <Route index element={<Consultant />} />
                      <Route path=":code" element={<Consultant />} /> */}
                  <Route path="/:id" element={<ExpertDetails />} />
                  <Route path="/error" element={<ErrorPage />} />
                </Routes>
              </ConsultantProvider>
            }
          />
          <Route path="/*" element={<PageNotFound />} />
        </Routes>
      </UrlProvider>
    </BrowserRouter>
  );
}
